export const URL_PARAMS = {
  nodeId: 'node_id',
  location: 'location',
  commentId: 'comment_id',
} as const;
